import React, { Dispatch, SetStateAction } from "react";
import "./CaseManagementHeader.scss";
import Button from "components/Buttons/Button";
import { useIntl } from "react-intl";

interface CaseManagementHeaderProps {
    tab: {
        requestForm: string;
        myRequests: string;
    };
    selectedtab: string;
    setSelected: Dispatch<SetStateAction<string>>;
    isOpenRequests: boolean;
    setIsOpenRequests: Dispatch<SetStateAction<boolean>>;
}

const CaseManagementHeader = ({
    tab,
    selectedtab,
    isOpenRequests,
    setIsOpenRequests,
    setSelected,
}: CaseManagementHeaderProps) => {
    const { formatMessage } = useIntl();

    const onCreateSupportRequest = () => {
        setSelected(tab.requestForm);
        setIsOpenRequests(false);
    };
    const onDisplaySupportRequest = () => {
        setSelected(tab.myRequests);
        setIsOpenRequests(false);
    };

    const selectedTabText =
        selectedtab === tab.myRequests
            ? formatMessage({ id: "case_management.tab.my_requests_text_selected" })
            : selectedtab;

    const selectedButton =
        selectedtab === tab.myRequests ? (
            <Button
                variant="primary"
                className="request-button requests-button-open"
                onClick={onCreateSupportRequest}
                size="small"
                id="requestForm"
            >
                {tab.requestForm}
            </Button>
        ) : (
            <Button
                variant="secondary"
                onClick={onDisplaySupportRequest}
                size="small"
                id="myRequests"
            >
                {tab.myRequests}
            </Button>
        );
    return (
        <div className={isOpenRequests ? "requests-closed" : "requests"}>
            <div className={isOpenRequests ? "request-container" : "request-container-open"}>
                <div className={isOpenRequests ? "header-container-closed" : "header-container"}>
                    <span className="header">
                        {isOpenRequests
                            ? formatMessage({ id: "case_management.header" })
                            : selectedTabText}
                    </span>
                </div>
                <div className={isOpenRequests ? "button-container-open" : "button-container"}>
                    {isOpenRequests ? (
                        <>
                            <Button
                                variant="primary"
                                onClick={onCreateSupportRequest}
                                className="requests-button requests-button-open"
                                size="small"
                                id="requestForm"
                            >
                                {tab.requestForm}
                            </Button>
                            <Button
                                variant="secondary"
                                className="requests-button"
                                onClick={onDisplaySupportRequest}
                                size="small"
                                id="myRequests"
                            >
                                {tab.myRequests}
                            </Button>
                        </>
                    ) : (
                        selectedButton
                    )}
                </div>
            </div>
        </div>
    );
};
export default CaseManagementHeader;
